module.exports = __webpack_public_path__ + "media/images/common/credit_cards/jcb-c498484351f74946fabcba014e2303a3.svg";